import { render, staticRenderFns } from "./DataTableExport.vue?vue&type=template&id=f056960e&scoped=true"
import script from "./DataTableExport.vue?vue&type=script&lang=js"
export * from "./DataTableExport.vue?vue&type=script&lang=js"
import style0 from "./DataTableExport.vue?vue&type=style&index=0&id=f056960e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f056960e",
  null
  
)

export default component.exports